<ion-app>
  <ion-router-outlet *ngIf="isTaskDetailsLoaded"></ion-router-outlet>

  <ion-header *ngIf="!isTaskDetailsLoaded" style="border-bottom: 0.5px solid gray;">
    <ion-toolbar class="header-background-style" style="position: relative; min-height: 56px;">
      <ion-title>
        <img *ngIf="_appServices?._themingService?.currentLogo?.value?.logoUrl"
          src="{{_appServices._themingService.currentLogo.value.logoUrl}}" class="header-logo" />
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content *ngIf="!isTaskDetailsLoaded" class="white-background ion-text-center">
    <div fxLayout="column" fxLayoutAlign="space-around center" class="loading-screen-content">
      <h2 class="welcometext">Welcome to your Assisted-Inspection</h2>
      <ion-spinner name="lines" class="loader-spinner"></ion-spinner>
      <p class="loadingdetails font-size-18 inter-regular color-netral-700">We are loading your details</p>
      <p class="refreshscreen color-netral-700 inter-regular font-size-14">Please do not refresh or close this screen
      </p>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-around center" class="footer-content">
      <div class="footer color-netral-500">
        Powered by Digital Eyes™
      </div>
    </div>
  </ion-content>
</ion-app>